import axios from 'axios';
import authHeader from './auth-header';
const config = require("../config/config.js");

const API_URL = config.API_URL + 'transaction/';

class TransactionService {
  sendMoney(data) {
    return axios
      .post(API_URL + 'send', data, { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }
  sendProof(data) {
    return axios
      .post(API_URL + 'proof', data, { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response.data;
      });
  }
  getTransactions() {
    return axios
      .get(API_URL + 'listtransactions', { headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response;
      });
  }
  getTransactionFiltered(data) {
    return axios
      .post(API_URL + 'listtransactionsfiltered', data,{ headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response;
      });
  }
  getTransactionCSV(data) {
    return axios
      .post(API_URL + 'listtransactionscsv', data,{ headers: authHeader() })
      .then(response => {
        if (response.data.accessToken) {
          localStorage.setItem('user', JSON.stringify(response.data));
        }

        return response;
      });
  }
}

export default new TransactionService();
